import { useLanguage } from '../hooks/useLanguage'

export default function LanguageToggle({ dark = false }) {
  const { language, toggle } = useLanguage()

  return (
    <button
      onClick={toggle}
      className={`flex items-center gap-1 text-sm font-semibold px-3 py-1.5 rounded-full border transition-all ${
        dark
          ? 'border-charcoal text-charcoal hover:bg-charcoal hover:text-cream'
          : 'border-white/60 text-white hover:bg-white/20'
      }`}
    >
      <span className={language === 'en' ? 'opacity-100' : 'opacity-50'}>EN</span>
      <span className="opacity-40">|</span>
      <span className={`font-tamil ${language === 'ta' ? 'opacity-100' : 'opacity-50'}`}>தமிழ்</span>
    </button>
  )
}
